// client/src/hooks/useSalaries.js

import { useState, useCallback } from 'react';
import salaryService from '../services/salaryService';

const useSalaries = () => {
  const [salaries, setSalaries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchSalaries = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await salaryService.getSalaries();
      setSalaries(data);
      return data;
    } catch (err) {
      setError(err.message || 'Impossible de charger les salaires.');
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const saveSalary = useCallback(async (month, amount) => {
    setError('');
    try {
      return await salaryService.upsertSalary(month, amount);
    } catch (err) {
      setError(err.message || 'Erreur lors de la sauvegarde.');
      throw err;
    }
  }, []);

  const removeSalary = useCallback(async (month) => {
    setError('');
    try {
      return await salaryService.deleteSalary(month);
    } catch (err) {
      setError(err.message || 'Erreur lors de la suppression.');
      throw err;
    }
  }, []);

  return { salaries, loading, error, fetchSalaries, saveSalary, removeSalary };
};

export default useSalaries;
